import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import useRailsEnv from 'hooks/useRailsEnv'

import useIsServerSide from 'hooks/useIsServerSideContext'

import { defaultLang } from '.'

const defaultLangTest = 'en-AU'

const setLang = (isServer: boolean) => {
  if (!isServer) {
    return (
      document.getElementsByTagName('html')[0]?.getAttribute('lang') ||
      defaultLang
    )
  }

  return defaultLang
}

const SetLanguage: React.FC = ({ children }) => {
  const { i18n } = useTranslation()

  const railsEnv = useRailsEnv()

  const isServer = useIsServerSide()

  const lang = setLang(isServer)

  const detectedLanguage = railsEnv === 'test' ? defaultLangTest : lang

  useEffect(() => {
    i18n.changeLanguage(detectedLanguage)
  }, [detectedLanguage])

  return <>{children}</>
}

export default SetLanguage
